// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"470px","header":"header_header__JCZP_","mobileMenu":"header_mobileMenu__1F2yR","active":"header_active__3z65J"};